import script from "./pc-module-task-analysis-3.vue?vue&type=script&setup=true&lang=tsx"
export * from "./pc-module-task-analysis-3.vue?vue&type=script&setup=true&lang=tsx"

import "./pc-module-task-analysis-3.vue?vue&type=style&index=0&id=ba172b64&lang=scss"

const __exports__ = script;

export default __exports__